import { Menu as AntMenu } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { NotificationStatus } from 'api/notifications';
import { Clear16 } from 'components/atoms/icons';
import { NotificationsBadge } from 'components/molecules/notifications-badge';
import { useTranslation } from 'hooks/use-translation';

interface Props {
  pending: number;
  status: NotificationStatus;
  setStatus: (status: NotificationStatus) => void;
  refresh: () => void;
}

const Container = styled.div`
  margin: 0 calc(-1 * var(--layout-05));
  background: white;
`;

const StatusMenu = styled(AntMenu)`
  padding-top: var(--layout-01);
  margin: 0 var(--layout-05);
`;

export const Menu: FC<Props> = ({ status, setStatus, refresh, pending }) => {
  const clearedCaption = useTranslation('notifications.cleared');
  const newCaption = useTranslation('notifications.new');

  return (
    <Container>
      <StatusMenu
        selectedKeys={[status]}
        mode="horizontal"
        onClick={(event) => {
          const notification_status = event.key as NotificationStatus;

          if (
            status === NotificationStatus.New &&
            notification_status === NotificationStatus.New &&
            pending > 0
          ) {
            refresh();
          } else {
            setStatus(notification_status);
          }
        }}
      >
        <StatusMenu.Item key={NotificationStatus.New}>
          <NotificationsBadge
            pending={pending}
            text={newCaption}
            width="100%"
          />
        </StatusMenu.Item>
        <StatusMenu.Item key={NotificationStatus.Cleared} icon={<Clear16 />}>
          {clearedCaption}
        </StatusMenu.Item>
      </StatusMenu>
    </Container>
  );
};
